var MainMenuState = function(){};

MainMenuState.prototype = {
    init: function(args){
    },
    preload: function(){
    },
    create: function(){
        this.game.state.start('level');
    },
    update: function(){
    },
    render: function(){
    },
    shutdown: function(){
    },
};

module.exports = MainMenuState;



/*****************
 ** WEBPACK FOOTER
 ** ./src/gradience/states/main-menu.js
 ** module id = 4
 ** module chunks = 0
 **/